"use client";

import { QuizSideChip } from "../../../../components/quiz/_components/quiz-side-chip";
import { FloatingQuizCard } from "../../../../components/quiz/_components/floating-quiz-card";
import { useQuizScroll } from "../../../../components/quiz/hooks/use-quiz-scroll";
import { QUIZ_VARIANT_TEST_A, QUIZ_VARIANT_TEST_B } from "@/lib/utils/common/constants";

export function QuizTouchpoints({ variant }: { variant?: string | null }) {
  const { quizChipVisible, quizCardVisible, dismissQuizCard } = useQuizScroll(variant);

  if (variant !== QUIZ_VARIANT_TEST_A && variant !== QUIZ_VARIANT_TEST_B) return null;

  return (
    <>
      <QuizSideChip visible={quizChipVisible} />
      <FloatingQuizCard visible={quizCardVisible} onClose={dismissQuizCard} />
    </>
  );
}
